import clsx from "clsx";
import {
  IconButtonProps,
  IconButtonType,
} from "nvs-design-system/dist/IconButton/types";
import { IconButton } from "nvs-design-system/dist/IconButton";
import { useExpansionModalContext } from "./ExpansionModalContext";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<Partial<IconButtonProps>>;
const ExpansionModalButtonClose: React.FC<Props> = ({
  children,
  className,
  buttonType = IconButtonType.outline,
  ...props
}) => {
  const { isOpen, setIsOpen } = useExpansionModalContext();

  return (
    <IconButton
      onClick={() => setIsOpen(false)}
      aria-label="close expanded image button"
      className={clsx(
        "absolute top-5 right-5 z-20",
        !isOpen && "hidden",
        className,
      )}
      title="Collapse product from full screen"
      role="Close Modal"
      buttonType={buttonType}
      {...props}
    >
      {children}
    </IconButton>
  );
};

export default ExpansionModalButtonClose;
